export const APP_STORE_URL =
  "https://apps.apple.com/ng/app/inawo-guest/id6768661916";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.inawoo.inawoguest";
export const MOBILE_APP_PACKAGE = "com.inawoo.inawoguest";
export const BIRTHDAY_INVITATION_PATH = "/open/accept-team-invite";
export const WEDDING_INVITATION_PATH = "/open/wedding";

export function weddingIdentifier(value: unknown): string | null {
  return typeof value === "string" &&
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
      value
    )
    ? value
    : null;
}

export function weddingInvitationAppUrl(event: string): string {
  return `inawoguest:///open/wedding?event=${encodeURIComponent(event)}`;
}

export function birthdayInvitationToken(
  value: string | string[] | undefined
): string | null {
  return typeof value === "string" && value.length > 0 && value.trim() === value
    ? value
    : null;
}

export function birthdayInvitationAppUrl(token: string): string {
  return `inawoguest://open/accept-team-invite?token=${encodeURIComponent(
    token
  )}`;
}
